var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPandasSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M49.548,157.817c0,0-41.29-32.016-41.29-66.065c0-33.032,16.516-82.581,74.323-74.323 c41.685,5.955,49.548,82.581,49.548,82.581L49.548,157.817z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M462.453,157.817c0,0,41.29-32.016,41.29-66.065c0-33.032-16.516-82.581-74.323-74.323 c-41.685,5.955-49.548,82.581-49.548,82.581L462.453,157.817z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEBD2"
    },
    d: "M512,280.774c0,132.263-114.615,214.71-256.001,214.71S0,413.038,0,280.774 S141.98,33.032,256.001,33.032S512,148.511,512,280.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9D7C3"
    },
    d: "M165.162,421.063c0,41.048,40.67,74.323,90.839,74.323s90.839-33.275,90.839-74.323H165.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.065,305.549C297.291,264.258,280.775,256,256.001,256c-24.774,0-41.29,8.258-66.065,49.548 c-21.244,35.407-39.365,105.632-24.774,123.871c33.032,41.29,82.581,16.516,90.839,16.516c8.258,0,57.807,24.774,90.839-16.516 C361.43,411.181,343.308,340.954,322.065,305.549z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M305.549,247.742c0-22.804,18.487-41.29,41.29-41.29c24.774,0,99.097,49.549,99.097,82.581 s-39.967,72.452-74.323,49.548C346.839,322.065,305.549,264.258,305.549,247.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6B676E"
    },
    d: "M206.452,247.742c0-22.804-18.487-41.29-41.29-41.29c-24.774,0-99.097,49.549-99.097,82.581 s39.967,72.452,74.323,49.548C165.162,322.065,206.452,264.258,206.452,247.742z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#464655"
    },
    d: "M256.001,363.311c-15.03,0-57.807,2.834-57.807,16.516c0,24.819,52.742,42.62,57.807,41.29 c5.064,1.33,57.807-16.472,57.807-41.29C313.807,366.144,271.03,363.311,256.001,363.311z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#464655"
    },
    cx: 165.162,
    cy: 247.742,
    r: 16.516
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#464655"
    },
    cx: 346.839,
    cy: 247.742,
    r: 16.516
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPandasSvg);
export default __webpack_public_path__ + "static/media/pandasSVG.e1b67de38d3ec8cfa8ee14dad8e0dc32.svg";
export { ForwardRef as ReactComponent };